import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import FileList from "@icarius-common/fileUpload/fileList";
import FileInput from "@icarius-common/fileUpload/fileInput";
import Loader from "@icarius-common/loader";
import { importCourseCoursesMasterAction } from "../actions";

const UploadFileDialog = (props) => {

  const {
    open,
    isLoading,
    handleClose,
  } = props;

  const [files, setFiles] = useState(null);
  const [invalidFiles, setInvalidFiles] = useState(null);

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    setInvalidFiles(null);

    if (Boolean(files)) {

      const formDataToSend = new FormData();
      formDataToSend.append("FILE", files[0]);

      dispatch(importCourseCoursesMasterAction(formDataToSend))
        .then((resp) => {
          if (resp?.status === 200) {
            handleClose();
          } else {
            if (resp?.data?.invalidFiles) {
              setInvalidFiles(resp.data.invalidFiles);
            }
          }
        });
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("uploadFile")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <Loader open={isLoading} />
        <DialogContent>
          <FileInput
            acceptedFormats={[".zip"]}
            handleChange={(files) => setFiles(files)}
            preSubmitCallback={() => setInvalidFiles(null)}
          />
          <FileList
            files={files}
            filesWithError={invalidFiles}
            handleClick={() => setFiles(null)}
          />
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
          <ButtonDialogAction onClick={handleSubmit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default UploadFileDialog;